import styled from "styled-components";
import { Colors } from "../../values/colors";
import { pickTextColor } from "../../utils/theme";

export const Container = styled.div`
  padding: 1rem;
`;

export const Tab = styled.div`
  cursor: pointer !important;
  padding: 10px 20px;
  border: 1px solid ${Colors.primary};
  font-weight: bold;
  border-radius: 5px;
  color: ${Colors.primary};
  background: ${Colors.white};
  margin-right: 10px;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: ${Colors.ultraLightGray2};
  }

  &.active{
    background: ${Colors.primary};
    color: ${pickTextColor(Colors.primary)};
  }
`;